<div *ngIf="!selectedPerson" class="person-search">
  <span *ngIf="isSearchTabActive" translate>CourtBookingSave.SearchPlayerText</span>
  <span *ngIf="isAddNewPlayerTabActive" translate>CourtBookingSave.AddPlayerText</span>
  <div class="d-flex flex-row booking-save-add-player-tabs my-3">
    <div class="flex-grow-1 booking-save-add-player-tab"
      [ngClass]="{'booking-save-add-player-tab-active': isSearchTabActive}" (click)="setSearchTabActive()" translate>
      CourtBookingSave.SearchPlayerLabel
    </div>
    <div class=" flex-grow-1 booking-save-add-player-tab"
      [ngClass]="{'booking-save-add-player-tab-active': isAddNewPlayerTabActive}" (click)="setAddPlayerTabActive()"
      translate>
      CourtBookingSave.AddNewPlayerLabel</div>
  </div>
  <app-court-booking-save-player-search *ngIf="isSearchTabActive" [players]="players"
    (selectPerson)="selectPerson($event)">
  </app-court-booking-save-player-search>
  <app-court-booking-save-player-add-new *ngIf="isAddNewPlayerTabActive" [players]="players"
    (selectPerson)="selectPerson($event)">
  </app-court-booking-save-player-add-new>
</div>
<div *ngIf="selectedPerson">
  <div class="person-search person-search-selected">
    <app-court-booking-player-info [showRemoveButton]="true" [person]="selectedPerson"
      (removePerson)="clearSelectedPerson()"></app-court-booking-player-info>
  </div>
  <div>
    <app-player-rules-message *ngIf="playerRules" [rules]="playerRules" [categoryName]="categoryName">
    </app-player-rules-message>
  </div>
</div>
